<ng-container *ngFor="let menuItem of menuItems">

  <!-- Expandable section (sub-type): hide when visible === false -->
  <mat-expansion-panel
    *ngIf="menuItem.type === 'sub' && menuItem.visible !== false"
    [class]="menuItem.customCssClass"
    [expanded]="isExpanded(menuItem.state)"
    (opened)="onPanelOpened(menuItem.state)"
    (closed)="onPanelClosed(menuItem.state)"
    class="sidebar-exp-panel">
    <mat-expansion-panel-header class="sidebar-exp-header">
      <mat-panel-title class="sidebar-exp-title">
        {{ menuItem.name | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <app-menu-item [menuItem]="menuItem"></app-menu-item>
  </mat-expansion-panel>

  <!-- Direct link (link-type) -->
  <a *ngIf="menuItem.type === 'link' && menuItem.visible !== false"
    class="sidebar-direct-link relative"
    [routerLink]="['/', menuItem.state]"
    routerLinkActive="active"
    mat-ripple>
    {{ menuItem.name | translate }}
  </a>

  <!-- External link -->
  <a *ngIf="menuItem.type === 'extLink' && menuItem.visible !== false"
    class="sidebar-direct-link relative"
    [href]="menuItem.state"
    target="_blank"
    mat-ripple>
    {{ menuItem.name | translate }}
  </a>

</ng-container>
